import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import _classPrivateFieldSet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet2.js";
import { PERMISSIONS, permitted, permittedRole, permittedSome } from "@/assets/js/mcn-helpers";
import store from '../../../store/index';
var _lang = /*#__PURE__*/new WeakMap();
export class NavSideBar {
  constructor(lang) {
    var _store$getters$getLan;
    // the slash at the beginning of the url is necessary
    _classPrivateFieldInitSpec(this, _lang, (_store$getters$getLan = store.getters.getLanguage.language) !== null && _store$getters$getLan !== void 0 ? _store$getters$getLan : 'en');
    _defineProperty(this, "OverviewPage", {
      id: 'overview',
      translation_name: 'dashboardMenu.overview.title',
      url: ['/', _classPrivateFieldGet(_lang, this)].join(''),
      title: 'Overview',
      permission: PERMISSIONS.OVERVIEW.ID,
      permitted_roles: ['*'],
      icon: 'mdi-view-dashboard',
      divider: true
    });
    _defineProperty(this, "OrderPage", {
      id: 'orders',
      translation_name: 'dashboardMenu.orders.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'order'].join('/'),
      title: 'Orders',
      permission: PERMISSIONS.ORDERS.ID,
      permitted_roles: ['*'],
      icon: 'mdi-basket'
      //divider: true
    });
    _defineProperty(this, "SaleReportPage", {
      id: 'sale-reports',
      translation_name: 'dashboardMenu.sale_reports.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'sale-report'].join('/'),
      title: 'Sales Reports',
      permission: PERMISSIONS.SALE_REPORTS.ID,
      permitted_roles: ['*'],
      icon: 'mdi-file-chart'
    });
    _defineProperty(this, "ProductPage", {
      id: 'products',
      translation_name: 'dashboardMenu.product.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'product'].join('/'),
      title: 'Product',
      permission: PERMISSIONS.PRODUCTS.ID,
      permitted_roles: ['*'],
      icon: 'mdi-package-variant-closed'
    });
    _defineProperty(this, "productSalePage", {
      id: 'product-sale-pages',
      translation_name: 'dashboardMenu.product_sale_pages.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'product-sale-page'].join('/'),
      title: 'Product Sale pages',
      permission: PERMISSIONS.PRODUCT_SALE_PAGES.ID,
      permitted_roles: ['*'],
      icon: 'mdi-newspaper-variant-outline'
    });
    /*SalePageManagementPage = {
        id: 'sale-pages',
        group: 'sale-page',
        translation_name: 'dashboardMenu.sale_pages.title',
        url: [this.#lang ? `/${this.#lang}` : null, 'sale-page'].join('/'),
        title: 'Sale pages',
        some_permissions: [PERMISSIONS.SALE_PAGES.ORIGINAL.ID, PERMISSIONS.SALE_PAGES.GENERATED.ID],
        permitted_roles: ['*'],
        icon: 'mdi-newspaper-variant-outline',
        isPermitted: () => this.isPermitted(this.SalePageManagementPage),
        hasMultipleVisibleChildren() {
            return this.children.reduce((init, child) => init + child.isPermitted(), 0) > 1
        },
        getAllowedChild() {
            return this.children.find(child => child.isPermitted())
        },
        children: [
            {
                id: NavSideBar.getOriginalSalePageId(),
                translation_name: 'dashboardMenu.sale_pages.children.original_sale_pages.title',
                url: [this.#lang ? `/${this.#lang}` : null, 'sale-page'].join('/'),
                title: 'Original sale pages',
                permission: PERMISSIONS.SALE_PAGES.ORIGINAL.ID,
                permitted_roles: ['*'],
                icon: 'mdi-newspaper-variant-outline',
                isPermitted: () => this.isPermitted(this.SalePageManagementPage.children[0]),
            },
            {
                id: NavSideBar.getSalePageInstanceId(),
                translation_name: 'dashboardMenu.sale_pages.children.generated_sale_pages.title',
                url: [this.#lang ? `/${this.#lang}` : null, 'sale-page/generated-sale-pages'].join('/'),
                title: 'Generated sale pages',
                permission: PERMISSIONS.SALE_PAGES.GENERATED.ID,
                permitted_roles: ['*'],
                icon: 'mdi-newspaper-variant-multiple-outline',
                isPermitted: () => this.isPermitted(this.SalePageManagementPage.children[1]),
            }
        ]
    }*/
    /*PreSalePageManagementPage = {
        id: 'pre-sells',
        group: 'pre-sell-page',
        translation_name: 'dashboardMenu.pre_sell_pages.title',
        url: [this.#lang ? `/${this.#lang}` : null, 'pre-sell-page'].join('/'),
        title: 'Pre-Sell pages',
        some_permissions: [PERMISSIONS.PRE_SALE_PAGES.ORIGINAL.ID, PERMISSIONS.PRE_SALE_PAGES.GENERATED.ID],
        permitted_roles: ['*'],
        divider: true,
        icon: 'mdi-newspaper',
        isPermitted: () => this.isPermitted(this.SalePageManagementPage),
        hasMultipleVisibleChildren() {
            return this.children.reduce((init, child) => init + child.isPermitted(), 0) > 1
        },
        getAllowedChild() {
            return this.children.find(child => child.isPermitted())
        },
        children: [
            {
                id: 'pre-sell-pages',
                translation_name: 'dashboardMenu.pre_sell_pages.children.original_pre_sell_pages.title',
                url: [this.#lang ? `/${this.#lang}` : null, 'pre-sell-page'].join('/'),
                title: 'Original sale pages',
                permission: PERMISSIONS.PRE_SALE_PAGES.ORIGINAL.ID,
                permitted_roles: ['*'],
                icon: 'mdi-newspaper',
                isPermitted: () => this.isPermitted(this.SalePageManagementPage.children[0]),
            },
            {
                id: 'pre-sell-pages-instances',
                translation_name: 'dashboardMenu.pre_sell_pages.children.generated_pre_sell_pages.title',
                url: [this.#lang ? `/${this.#lang}` : null, 'pre-sell-page/generated-pre-sell-pages'].join('/'),
                title: 'Generated sale pages',
                permission: PERMISSIONS.PRE_SALE_PAGES.GENERATED.ID,
                permitted_roles: ['*'],
                icon: 'mdi-newspaper-plus',
                isPermitted: () => this.isPermitted(this.SalePageManagementPage.children[1]),
            },
        ]
    }*/
    _defineProperty(this, "store", {
      id: 'store-page',
      group: 'store',
      translation_name: 'dashboardMenu.store.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'sale-page'].join('/'),
      title: 'Sale pages',
      some_permissions: [PERMISSIONS.STORE.STORES.ID, PERMISSIONS.STORE.STORE_PAGES.ID],
      permitted_roles: ['*'],
      icon: 'mdi-store',
      children: [{
        id: 'domains',
        translation_name: 'dashboardMenu.domains.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'store/domain'].join('/'),
        title: 'Domains',
        permission: PERMISSIONS.STORE.DOMAINS.ID,
        permitted_roles: ['*'],
        icon: 'mdi-dns'
      }, {
        id: 'store-page',
        translation_name: 'dashboardMenu.store.children.store_settings.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'store'].join('/'),
        title: 'Domains',
        permission: PERMISSIONS.STORE.STORES.ID,
        permitted_roles: ['*'],
        icon: 'mdi-store-cog'
      }, {
        id: 'store-pages-page',
        translation_name: 'dashboardMenu.store.children.store_pages.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'store/page'].join('/'),
        title: 'Domains',
        permission: PERMISSIONS.STORE.STORE_PAGES.ID,
        permitted_roles: ['*'],
        icon: 'mdi-store-edit'
      }, {
        id: 'store-layout-page',
        translation_name: 'dashboardMenu.store.children.store_layouts.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'store/layout'].join('/'),
        title: 'Domains',
        permission: PERMISSIONS.STORE.STORE_LAYOUTS.ID,
        permitted_roles: ['*'],
        icon: 'mdi-store-plus'
      }, {
        id: 'media-library',
        translation_name: 'dashboardMenu.media_library.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'store/library'].join('/'),
        title: 'Media Library',
        permission: PERMISSIONS.STORE.LIBRARY.ID,
        permitted_roles: ['*'],
        icon: 'mdi-folder-multiple-image'
      }]
    });
    _defineProperty(this, "BusinessManagersPage", {
      id: 'business-managers',
      group: 'applications',
      translation_name: 'dashboardMenu.business_managers.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'applications/woocommerce'].join('/'),
      title: 'Business Managers',
      permission: PERMISSIONS.BUSINESS_MANAGERS.ID,
      permitted_roles: ['*'],
      icon: 'mdi-application-brackets',
      children: [
      /*            {
                      id: 'woocommerce',
                      translation_name: 'dashboardMenu.business_managers.children.woocommerce.title',
                      url: [this.#lang ? `/${this.#lang}` : null, 'applications/woocommerce'].join('/'),
                      title: 'WooCommerce',
                      permission: PERMISSIONS.BUSINESS_MANAGERS.WOO_COMMERCE.ID,
                      permitted_roles: ['*'],
                      icon: 'mdi-alpha-w-circle-outline',
                  },*/
      {
        id: 'google-sheet',
        translation_name: 'dashboardMenu.business_managers.children.google_sheet.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'applications/google-sheet'].join('/'),
        title: 'Google Sheet',
        permission: PERMISSIONS.BUSINESS_MANAGERS.GOOGLE_SHEET.ID,
        permitted_roles: ['*'],
        icon: 'mdi-google-spreadsheet'
      }, {
        id: 'google-shopping',
        translation_name: 'dashboardMenu.business_managers.children.google_shopping.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'applications/google-shopping'].join('/'),
        title: 'Google Shopping',
        permission: PERMISSIONS.BUSINESS_MANAGERS.GOOGLE_SHOPPING.ID,
        permitted_roles: ['*'],
        icon: 'mdi-google-my-business'
      }, {
        id: 'facebook-shopping',
        translation_name: 'dashboardMenu.business_managers.children.facebook_shopping.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'applications/facebook-shopping'].join('/'),
        title: 'Facebook Shopping',
        permission: PERMISSIONS.BUSINESS_MANAGERS.FACEBOOK_SHOPPING.ID,
        permitted_roles: ['*'],
        icon: 'mdi-facebook'
      }]
    });
    _defineProperty(this, "WarehousePage", {
      id: 'warehouse-settings',
      group: 'warehouse-settings',
      translation_name: 'dashboardMenu.warehouse.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'warehouse-settings'].join('/'),
      title: 'Warehouses',
      permission: PERMISSIONS.WAREHOUSES_SETTINGS.ID,
      permitted_roles: ['*'],
      icon: 'mdi-warehouse',
      children: [{
        id: 'warehouses',
        translation_name: 'dashboardMenu.warehouse.children.warehouse.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'warehouse-settings/warehouses'].join('/'),
        title: 'Warehouses',
        permission: PERMISSIONS.WAREHOUSES_SETTINGS.WAREHOUSES.ID,
        permitted_roles: ['*'],
        icon: 'mdi-warehouse'
      }, {
        id: 'inventory-overview',
        translation_name: 'dashboardMenu.warehouse.children.inventory.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'warehouse-settings/inventory'].join('/'),
        title: 'Inventory Overview',
        permission: PERMISSIONS.WAREHOUSES_SETTINGS.INVENTORY.ID,
        permitted_roles: ['*'],
        icon: 'mdi-qrcode-scan',
        divider: true
      }, {
        id: 'network-sdks',
        translation_name: 'dashboardMenu.warehouse.children.external_api.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'warehouse-settings/network-sdks'].join('/'),
        title: 'Network Sdks',
        permission: PERMISSIONS.WAREHOUSES_SETTINGS.EXTERNAL_API.ID,
        permitted_roles: ['*'],
        icon: 'mdi-network'
      }]
    });
    _defineProperty(this, "referralProgram", {
      id: 'referral-program',
      group: 'referral-program',
      translation_name: 'dashboardMenu.referral_program.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'referral-program'].join('/'),
      title: 'Referral Program',
      permission: PERMISSIONS.REFERRALS_PROGRAM.ID,
      permitted_roles: ['*'],
      icon: 'mdi-account-heart',
      children: [{
        id: 'referral-link',
        translation_name: 'dashboardMenu.referral_program.children.link.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'referral-program/link'].join('/'),
        title: 'Referral Program',
        permission: PERMISSIONS.REFERRALS_PROGRAM.LINK.ID,
        permitted_roles: ['*'],
        icon: 'mdi-link-variant'
      }, {
        id: 'referral-invoices',
        translation_name: 'dashboardMenu.referral_program.children.invoices.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'referral-program/invoice'].join('/'),
        title: 'Referrals',
        permission: PERMISSIONS.REFERRALS_PROGRAM.INVOICES.ID,
        permitted_roles: ['*'],
        icon: 'mdi-invoice'
      }, {
        id: 'referral-payouts',
        translation_name: 'dashboardMenu.referral_program.children.payouts.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'referral-program/payouts'].join('/'),
        title: 'Referrals',
        permission: PERMISSIONS.REFERRALS_PROGRAM.PAYOUTS.ID,
        permitted_roles: ['*'],
        icon: 'mdi-cash-clock'
      }]
    });
    _defineProperty(this, "SupportPage", {
      id: 'support',
      group: 'support',
      translation_name: 'dashboardMenu.support.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'support'].join('/'),
      title: 'Support',
      permission: PERMISSIONS.SUPPORT.ID,
      permitted_roles: ['*'],
      icon: 'mdi-lifebuoy',
      divider: true,
      children: [{
        id: 'support-faq',
        translation_name: 'dashboardMenu.support.children.faq.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'support/faq'].join('/'),
        title: 'Faqs',
        permission: PERMISSIONS.SUPPORT.FAQS.ID,
        permitted_roles: ['*'],
        icon: 'mdi-frequently-asked-questions'
      }, {
        id: 'support-ticket',
        translation_name: 'dashboardMenu.support.children.ticket.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'support/ticket'].join('/'),
        title: 'Tickets',
        permission: PERMISSIONS.SUPPORT.TICKETS.ID,
        permitted_roles: ['*'],
        icon: 'mdi-comment-check'
      }, {
        id: 'support-tutorials',
        translation_name: 'dashboardMenu.support.children.tutorials.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'support/tutorials'].join('/'),
        title: 'Tickets',
        permission: PERMISSIONS.SUPPORT.TUTORIALS.ID,
        permitted_roles: ['*'],
        icon: 'mdi-school'
      }]
    });
    _defineProperty(this, "settings", {
      id: 'settings',
      group: 'general-settings',
      translation_name: 'dashboardMenu.invoices.title',
      opened: false,
      key: 'settings',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'general-settings'].join('/'),
      title: 'Settings',
      permission: PERMISSIONS.INVOICES.ID,
      permitted_roles: ['*'],
      icon: 'mdi-cog',
      children: [{
        id: 'subscription-invoices',
        translation_name: 'dashboardMenu.invoices.children.subscription_invoices.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'general-settings/subscriptions'].join('/'),
        title: 'Subscription Invoices',
        permission: PERMISSIONS.INVOICES.SUBSCRIPTION_INVOICES.ID,
        permitted_roles: ['*'],
        icon: 'mdi-credit-card-clock-outline'
      }, {
        id: 'settings',
        translation_name: 'dashboardMenu.invoices.children.settings.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'general-settings/account'].join('/'),
        title: 'Settings',
        permission: PERMISSIONS.INVOICES.SETTINGS.ID,
        permitted_roles: ['*'],
        icon: 'mdi-account-cog',
        divider: true
      }]
    });
    _defineProperty(this, "CallCenterPage", {
      id: 'call-centers',
      translation_name: 'dashboardMenu.call_center.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'call-center'].join('/'),
      title: 'Call Center',
      permission: PERMISSIONS.CALL_CENTERS.ID,
      permitted_roles: ['*'],
      icon: 'mdi-face-agent'
    });
    _defineProperty(this, "AdvertiserPage", {
      id: 'advertisers',
      translation_name: 'dashboardMenu.advertiser.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'advertiser'].join('/'),
      title: 'Advertiser',
      permission: PERMISSIONS.ADVERTISERS.ID,
      permitted_roles: ['*'],
      icon: 'mdi-advertisements'
    });
    _defineProperty(this, "SellersPage", {
      id: 'sellers',
      translation_name: 'dashboardMenu.sellers.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'sellers'].join('/'),
      title: 'Sellers',
      permission: PERMISSIONS.AFFILIATES.ID,
      permitted_roles: ['*'],
      icon: 'mdi-account-hard-hat'
    });
    _defineProperty(this, "UserPage", {
      id: 'users',
      group: 'user',
      translation_name: 'dashboardMenu.users.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'user'].join('/'),
      title: 'Users',
      permission: PERMISSIONS.USERS.ID,
      permitted_roles: ['*'],
      icon: 'mdi-account-group',
      divider: true,
      children: [{
        id: 'user-accounts',
        translation_name: 'dashboardMenu.users.children.user_accounts.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'user/user-accounts'].join('/'),
        title: 'Users',
        permission: PERMISSIONS.USERS.USER_ACCOUNTS.ID,
        permitted_roles: ['*'],
        icon: 'mdi-account-group'
      }, {
        id: 'identity-verifications',
        translation_name: 'dashboardMenu.users.children.identity_verification.title',
        url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'user/identity-verification'].join('/'),
        title: 'Users',
        permission: PERMISSIONS.USERS.IDENTITY_VERIFICATION.ID,
        permitted_roles: ['*'],
        icon: 'mdi-account-multiple-check'
      }]
    });
    _defineProperty(this, "LogPage", {
      id: 'activities',
      translation_name: 'dashboardMenu.activity_logs.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'log'].join('/'),
      title: 'Activity Logs',
      permission: PERMISSIONS.ACTIVITY_LOGS.ID,
      permitted_roles: ['*'],
      icon: 'mdi-console'
    });
    _defineProperty(this, "loginPage", {
      id: 'login',
      translation_name: 'dashboardMenu.login.title',
      url: [_classPrivateFieldGet(_lang, this) ? `/${_classPrivateFieldGet(_lang, this)}` : null, 'login'].join('/'),
      enumerable: false,
      isVisible() {
        return this.enumerable !== false;
      }
    });
    _defineProperty(this, "registerPage", {
      id: 'register',
      translation_name: 'dashboardMenu.register.title',
      enumerable: false,
      isVisible() {
        return this.enumerable !== false;
      }
    });
    _defineProperty(this, "requestPasswordPage", {
      id: 'request-password',
      translation_name: 'dashboardMenu.request_password.title',
      enumerable: false,
      isVisible() {
        return this.enumerable !== false;
      }
    });
    _defineProperty(this, "resetPasswordPage", {
      id: 'reset-password',
      translation_name: 'dashboardMenu.reset_password.title',
      enumerable: false,
      isVisible() {
        return this.enumerable !== false;
      }
    });
    _defineProperty(this, "registerConfirmationPage", {
      id: 'register-confirmation',
      translation_name: 'dashboardMenu.register_confirmation.title',
      enumerable: false,
      isVisible() {
        return this.enumerable !== false;
      }
    });
    _defineProperty(this, "instagramRedirectPage", {
      id: 'instagram-redirect-confirmation',
      translation_name: 'dashboardMenu.instagram_redirect.title',
      enumerable: false,
      isVisible() {
        return this.enumerable !== false;
      }
    });
    if (lang) _classPrivateFieldSet(_lang, this, lang);
  }
  static getTutorialsPath() {
    return '/support/tutorials';
  }
  getSupportPageUrl() {
    return this.SupportPage.url;
  }
  getTicketPageUrl() {
    return this.SupportPage.children[1].url;
  }
  getSupportPageId() {
    return this.SupportPage.children[1].id;
  }
  getLoginPageUrl() {
    return this.loginPage.url;
  }
  isPermitted(context) {
    return (permitted(context.permission) || permittedSome(context.some_permissions)) && permittedRole(context.permitted_roles);
  }
  static getOriginalSalePageId() {
    return 'sale-pages';
  }
  static getSalePageInstanceId() {
    return 'sale-pages-instances';
  }
  static getProductSalePagePath() {
    return '/product-sale-page';
  }
}
export default NavSideBar;